var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course",staticStyle:{"height":"100%","font-size":"0"}},[_c('iframe',{ref:"myIframe",staticStyle:{"height":"calc(100vh - 72px)"},attrs:{"src":_vm.iframeUrl,"frameborder":"0","scrolling":"auto","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }